import * as React from 'react';
import CalendarMonthConfig from '../interfaces/CalendarMonthConfig';
import FocusableSurfaceComponent from './FocusableSurfaceComponent';
import SurfaceStore from '../interfaces/SurfaceStore';
import { attachBehaviors } from './BehaviorsHelper';
import { logMountingPerformance } from 'owa-analytics';
import { observer } from 'mobx-react';

let styles = require('./MonthSurface.scss');
let classNames = require('classnames/bind').bind(styles);

/**
 * Props for calendar surface
 */
export interface MonthSurfaceProps {
    config: CalendarMonthConfig;
    store: SurfaceStore;
}

/**
 * This is a container page for several calendar controls
 * Similar to OWA with 2 controls showing all day and regular items
 */
@logMountingPerformance('CalendarMonthView')
@observer
export default class MonthSurface extends React.Component<MonthSurfaceProps, {}> {
    render() {
        let { config } = this.props;
        let content = config.contentGenerator();
        const showRowHeaders = !!content.rowHeaders;
        let tabOrder = content.tabOrder;

        return (
            <FocusableSurfaceComponent
                setFocusedElement={config.setFocusedElement}
                tabOrderProvider={() => tabOrder}
                ref={config.surfaceComponent}>
                <div className={styles.page}>
                    <div className={classNames(styles.header, { shiftedHeader: showRowHeaders })}>
                        {content.columnHeaders}
                    </div>
                    {showRowHeaders && (
                        <div key="monthRowHeaderBehavior" className={styles.rowHeaders}>
                            {content.rowHeaders}
                        </div>
                    )}
                    {attachBehaviors(
                        <div
                            key="monthContentBehavior"
                            className={classNames(styles.itemsPanel, {
                                shiftedItemsPanel: showRowHeaders,
                            })}>
                            {content.content}
                        </div>,
                        config.behaviors
                    )}
                </div>
            </FocusableSurfaceComponent>
        );
    }
}
